export const KEYWORDS = 'KEYWORDS';
export const KEYWORDS_EXTENSION = 'KEYWORDS_EXTENSION';
export const KEYWORDS_EXTENSION_FILETYPE = 'KEYWORDS_EXTENSION_FILETYPE';
export const KEYWORDS_FILETYPE = 'KEYWORDS_FILETYPE';
export const EXTENSION = 'EXTENSION';
export const EXTENSION_FILETYPE = 'EXTENSION_FILETYPE';
export const FILETYPE = 'FILETYPE';